import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles({
    root: {
      minWidth: 175,
      minHeight: 150,
      backgroundColor: '#2d2d2d'
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
      color: 'white'
    },
    pos: {
      marginBottom: 5,
      color: 'white',
      textAlign: 'center'
    },

  });
  
 const RuleCard = () => {
    const classes = useStyles();
    const bull = <span className={classes.bullet}>•</span>;
  
    return (
      <Card className={classes.root}>
        <CardContent>
        <Typography className={classes.pos} color="textSecondary">
              When you have hit
          </Typography>   
          <Typography variant="h5" component="h2">
            B{bull}I{bull}N{bull}G{bull}O
          </Typography>  
          <Typography className={classes.pos} color="textSecondary">
            Announce first to Discord to Win!
          </Typography>
        </CardContent>
        <CardActions>
            
        </CardActions>
      </Card>
    );
  }


export default RuleCard